const modules = import.meta.glob('./templates/*.ts', { eager: true });

export const DEFAULT_TEMPLATES = Object.values(modules).map((mod: any) => mod.default);
